

import { defineComponent, onBeforeUnmount, onMounted } from 'vue'
import { basketStore, eventEmitter } from 'partners-widget-core'

const BASKET_MINI_COUNTER_SELECTOR = '.book24-widget-basket-mini__counter'

export default defineComponent({
  name: 'App',
  setup () {
    let counterElement: HTMLElement | null = null

    const onStoreChange = (store: typeof basketStore.store): void => {
      if (counterElement) {
        counterElement.textContent = store.syncProducts.length.toString()
      }
    }

    onMounted(() => {
      eventEmitter.on('basket-store-changed', onStoreChange)
      counterElement = document.querySelector(BASKET_MINI_COUNTER_SELECTOR)
      onStoreChange(basketStore.store)
    })

    onBeforeUnmount(() => {
      eventEmitter.off('basket-store-changed', onStoreChange)
    })
  },
})

